import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import IconSchools from '../../base/components/IconSchools'
import IconSubjects from '../../base/components/IconSubjects'
import IconRegions from '../../base/components/IconRegions'

export default function FilterNav({
  section,
  onOpenSection
}) {

  return (
    <div className="filter-nav">
      <nav>
        <ul className="nav nav-main nav-filters">
          <li>
            <button
              className={classNames(
                'bg-tab-schools',
                'filter-nav-link',
                'btn-plain',
                { active: section === 'schools' }
              )}
              title="Nach Schulen filtern"
              value="schools"
              onClick={onOpenSection}
            >
              <IconSchools />
            </button>
          </li>
          <li>
            <button
              className={classNames(
                'bg-tab-subjects',
                'filter-nav-link',
                'btn-plain',
                { active: section === 'subjects' }
              )}
              title="Nach Schulfächern filtern"
              value="subjects"
              onClick={onOpenSection}
            >
              <IconSubjects />
            </button>
          </li>
          <li>
            <button
              className={classNames(
                'bg-tab-regions',
                'filter-nav-link',
                'btn-plain',
                { active: section === 'regions' }
              )}
              title="Nach Landkreis filtern"
              value="regions"
              onClick={onOpenSection}
            >
              <IconRegions />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  )

}

FilterNav.propTypes = {
  onOpenSection: PropTypes.func.isRequired,
  section: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/frontend/map/components/FilterNav.js